var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,muiLoaderOptions} from '../../utils';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff!important',
            fill: '#ffffff'
        },
        "& .MuiSvgIcon-root": {
            color: '#ffffff',
            fill: '#ffffff',
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },
        "& .MuiButton-root": {
            fontSize: "0.7rem"
        },
//.datatables-noprint
    },

}));

export default function ReportUserTasks() {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [expand, setExpand] = React.useState(false);
    const [filters, setFilters] = React.useState(['Active']);
    const [showExpired, setShowExpired] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    const classes = pageStyles();

    const getData = async () => {
        await fetch(`/api/Reports/UserTasks/${showExpired}`, {
       //     ${ expand }
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                
					setDataSet(json);
                setIsLoading(false);
                //logger("fetch", json)
            })

    };

    const columns = [
        {
            name: "User",
            options: {
                filter: true,
                sort: false,
                sortCompare: (order) => {
            return ({ dataSet: a }, { dataSet: b }) => {
            return (parseInt(a) - parseInt(b)) * (order === "asc" ? 1 : -1);
          };
        },
                customBodyRender: (value, tableMeta, updateValue) => {
                        return (`${dataSet[tableMeta.rowIndex].User}`);
                }   
            }
        },
        {
            name: "Role",
            options: {
                filter: true,
                sort: false,
                sortCompare: (order) => {
                    return ({ dataSet: a }, { dataSet: b }) => {
                        return (parseInt(a) - parseInt(b)) * (order === "asc" ? 1 : -1);
                    };
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    const isActiveRole = dataSet[tableMeta.rowIndex].isActiveRole;
                    const rowStyle = isActiveRole ? {} : {color: 'red'};
                    return (
                        <Tooltip title={!isActiveRole ? `Role:${dataSet[tableMeta.rowIndex].Role} is Inactive`: ""} placement="top-end">
                            <div style={rowStyle}>
                                {dataSet[tableMeta.rowIndex].Role}
                            </div>
                        </Tooltip>
                    );
                }
            }
        },       
        {
            name: "Tasks",
            label: "Available Tasks",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
					const rowIndex = tableMeta.rowIndex;
					const user = dataSet[rowIndex]?.User;
					const statuses = dataSet[rowIndex]?.Statuses || ""; // Ensure statuses is correctly indexed
					const tasks = dataSet[rowIndex]?.Tasks.split("|");
			        const statusArray = statuses.split(",");
			
			        return tasks.map((task, idx) => {
			            const isExpired = statusArray[idx] === 'expired';
			            const rowStyle = isExpired ? { color: 'red' } : {};
			            
			            //logger("Task:", task, "Status:", statusArray[idx], "isExpired:", isExpired); // Debugging line
			            
			            return (
                            <Tooltip title={isExpired ? `Task:${task} is Expired`: ""} placement="top-end">
                                <div key={idx} style={rowStyle}>
                                    {task}
                                    <br />
                                </div>
                            </Tooltip>
			            );
			        });
				}
            }
        },
        {
            name: "LPs",
            label: "L&Ps",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    logger(value);
                    const rowIndex = tableMeta.rowIndex;
                    logger("rowIndex", rowIndex)
                    const statuses = dataSet[rowIndex]?.Statuses || ""; // Ensure statuses is correctly indexed
                    
                    
                    const tasks = dataSet[rowIndex]?.LPs.split("|");
			        const statusArray = statuses.split(",");
			
			        return tasks.map((task, idx) => {
			            const isExpired = statusArray[idx] === 'expired';
			            const rowStyle = isExpired ? { color: 'red' } : {};
			            
			            //logger("Task:", task, "Status:", statusArray[idx], "isExpired:", isExpired); // Debugging line
			            
			            return (
                            <Tooltip title={isExpired ? `Task:${task} is Expired`: ""} placement="top-end">
                                <div key={idx} style={rowStyle}>
                                    {task}
                                    <br />
                                </div>
                            </Tooltip>
			            );
			        });
                    
                    
                    //return <ExpiredTaskRow value={value} statuses={statuses} />;
                          
                }
            }
        },

        {
            name: "POs",
            label: "PO",
            options: {
                filter: true,
                sort: false,
                sortCompare: (order) => {
                    return ({ dataSet: a }, { dataSet: b }) => {
                        return (parseInt(a) - parseInt(b)) * (order === "asc" ? 1 : -1);
                    };
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (dataSet[tableMeta.rowIndex].POs)
                        return (`${dataSet[tableMeta.rowIndex].POs}`);
                    else
                        return (
                            <Tooltip title='Failing' className={classes.root}>
                                <ReportGmailerrorredIcon color='error' />
                            </Tooltip>
                        );
                }
            }
        },
         {
            name: "Projects",
            label: "Project",
             options: {
                 filter: false,
                 sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    //    logger(`value`, value);

                    if (dataSet[tableMeta.rowIndex].Projects.includes("|")) {
                        //      logger(`IF value`, value);
                        return dataSet[tableMeta.rowIndex].Projects.split("|").map((item, idx) => {
                            //        logger(`item`, item);
                            return (
                                <React.Fragment key={idx}>
                                    {item}
                                    <br />
                                </React.Fragment>
                            );
                        });
                    } else {
                        return <React.Fragment>{dataSet[tableMeta.rowIndex].Projects}</React.Fragment>;
                    }
                }
            }
        },
 /*       {
            name: "LPStart",
            label: "Coverage Starts",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].LPStart).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "LPEnd",
            label: "Coverage Ends",
            options: {
                filter: false,
                sort: true,
                //    position: "sticky",
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].LPEnd).format("MM/DD/YYYY")
                    );
                }
            }
        },*/

        {
            name: "isActiveRole",
            label: "Active Role",
            options: {
                filter: true,
                sort: false,
                empty: true,
                display: false,
                filterList: filters,
                filterOptions: {
                    names: ['NotActive', 'Active'],
                    logic: (isActive, filters, row) => {
                        if(filters.includes('Active')) {
                            return !(isActive === 1);
                        } else if(filters.includes('NotActive')) {
                            return !(isActive === 0);
                        }
                        return false
                    }
                },
            }
        },


    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        sortOrder: {
            name: 'User',
            direction: 'asc'
        },
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        rowsPerPage: initialRowsPerPage,
        responsive: 'standard',
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',
        textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		  onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				return customBodyForExcelReport({data:data, headers:headers});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename: 'UserTask.xlsx'});
			return false;
		},

        onFilterChange: (columnChanged, filterList) => {
            if(columnChanged == "isActiveRole") {
                setFilters(filterList[6]);
            }
        },
		
		customToolbar: () => (
            <div>
                <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
                        <Grid container spacing={5} justifyContent="flex-end">                          
	                        <Grid item xs={12}>
                                <Tooltip title="click to include InActive Tasks" placement="top-end">
                                    <FormControlLabel
                                        name="Expand"
                                        label="Expand"
                                        style={{ color: 'white' }}
                                        control={<Checkbox
                                            checked={showExpired}
                                            labelStyle={{ color: 'white' }}
                                            iconStyle={{ fill: 'white' }}
                                            inputStyle={{ color: 'white' }}
                                            style={{ color: 'white' }}
                                            onChange={e => {showExpiredRecords(!showExpired);}}
                                        />}
                                    />
                                </Tooltip>
	                        </Grid>
                        </Grid>
                </MuiPickersUtilsProvider>
            </div>
        )
    };
    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setExpand(false);
    };
    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
         //   logger("expand" + expand)
            getData()

            setRefresh(false);
        }

    })
    
    const showExpiredRecords = (show_expired_records) => {
        setShowExpired(show_expired_records);
        logger("show_expired_records", show_expired_records);
        setRefresh(true);
    };
    
    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div className={classes.root}>
            {logger("first",dataSet[0])}
            <Button variant="contained" onClick={handleClickOpen}>
                User Task List
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
                <Dialog className={classes.root} open={open} onClose={handleClose} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                    <DialogContent >
                        <Box>

                            <MUIDataTable className={classes.root}
                                title={

                                    <Typography variant="h6" style={{ color: "white" }}>
                                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close"> <CloseIcon /> </IconButton>
                                        User Tasks
                                    </Typography>
                                }
                                data={isLoading ? [] :dataSet}
                                columns={columns}
                                options={muiLoaderOptions(options, isLoading)}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
            </MuiThemeProvider>
        </div>
    );
}

 